import type {
  AppContext,
  Result,
  Selection
} from "@/types/scheduling";
import type { WritableDraft } from "immer";

import { produce } from "immer";

export const handleClearCurrentValue = <T extends AppContext>(context: T, params: {key: string}) => {
  return produce(context, (draft: WritableDraft<AppContext>) => {
    (draft.result[params.key as keyof Result] as Selection) = {
      value: "",
      key: "",
      label: "",
    };
    if (params.key === "day") {
      draft.slots = undefined;
    }
    if (params.key === "insurance_provider_other") {
      draft.result.insurance_provider_other = ""
      draft.next_allowed.insurance_selection_other = false
    }
    if (params.key === "lead_name") {
      draft.result.lead_name = ""
      draft.next_allowed.lead_name = false
    }
    if (params.key === "lead_email") {
      draft.result.lead_email = ""
      draft.next_allowed.lead_email = false
    }
    if (params.key === "lead_phone_number") {
      draft.result.lead_phone_number = ""
      draft.next_allowed.lead_phone_number = false
    }
  });
}
